<template>
  <div class="adjust_ui">
    <Breadcrumb></Breadcrumb>
    <div class="adjust_content">
      <div class="adjust_title">
        <div class="classMsg">
          <p v-if="classMsg.searchSchoolClassId">{{classMsg.class}} {{classNmae[classMsg.searchOneSection-1]}}{{classMsg.subject}} <i class="el-icon-close" @click="closeBtn"></i></p>
        </div>
        <!-- <el-dropdown>
          <span class="el-dropdown-link">
            2019-2020第二学期第18周(06/07-06/13)<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="myMenu">
            <el-dropdown-item v-for="item in option" :key="item.week">{{semester.name}}{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <div class="change-box">
            <p>{{semester.name+weekName}}<i class="el-icon-arrow-down el-icon--right"></i></p>
            <el-select v-model="week.week" class="mySelect" @change="setWeek">
              <el-option
                v-for="item in option"
                :key="item.week"
                :label="semester.name+item.name"
                :value="item.week"
                :disabled="item.disabled">
              </el-option>
            </el-select>
        </div>
        <div class="classSign">
          <span v-if="!classMsg.searchSchoolClassId" class="hasClass">有课</span>
          <span v-if="!classMsg.searchSchoolClassId" class="noClass">无课</span>
          <span v-if="classMsg.searchSchoolClassId">可调课表</span>
        </div>
      </div>
      <table v-if="weekClass.length">
        <tr :class="{hasTiaoke:classMsg.searchSchoolClassId}">
          <th v-for="(item,index) in weeks" :key="index">
            <span class="date_box" :class="{hasClass:hasClass[index]}" >{{(days[index].getMonth()+1>=10?days[index].getMonth()+1:'0'+(days[index].getMonth()+1))+'/'+(days[index].getDate()>=10?days[index].getDate():'0'+days[index].getDate())}}</span>
            <span class="nowDate" v-if="days[index].getFullYear() == new Date().getFullYear() && days[index].getMonth() == new Date().getMonth() && days[index].getDate() == new Date().getDate()">今</span>
            <span v-else>{{item}}</span>
          </th>
        </tr>
        <tr v-for="(item,index) in weekClass" :key="index">
          <td v-for="(val,num) in item" :key="num">
            <div v-if="val.id" :class="{current:classMsg.searchSchoolClassId}">
              <p v-if="classMsg.searchSchoolClassId">{{val.name}}</p>
              <p>{{val.show_schoolTypeName}} {{val.class}}</p>
              <p>{{classNmae[val.section-1]}}{{val.subject}}</p>
              <span v-if="classMsg.searchSchoolClassId" class="change-btn" :class="{disabled:val.disabled}"  @click="apply_btn(val)">申请调课</span>
              <span v-else class="change-btn" @click="selectCourse(val)" :class="{disabled:val.disabled}">查看可调课表</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getWeekList,myLessonTable,listSchoolSemester,exchangeLessonTable,applyChange} from '@/api/common_api'

import { Breadcrumb } from '@/components'

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      currentDay: 1,
      currentMonth: 1,
      currentYear: 1970,
      currentWeek: 1,
      days: [],
      hasClass: [],
      option: [],
      value: 0,
      show: false,
      pitchDay: "",
      semester: {},
      week: {},
      weekName:'',
      index: "",
      weekClass: [],
      weeks:['周一','周二','周三','周四','周五','周六','周日',],
      classNmae:['第一节课','第二节课','第三节课','第四节课','第五节课','第六节课','第七节课','第八节课','第九节课','第十节课'],
      classMsg:{}
    };
  },
  created() {
    this.getWeek();
    this.getSemester();
  },
  methods: {
    // 获取周列表
    getWeek() {
      getWeekList().then(res => {
        if (res.s == 1) {
          res.d.map((val, index) => {
            val.text = val.name.replace(/-/g, "/");
            if (val.present == 1) {
              this.week = JSON.parse(JSON.stringify(val));
              this.weekName = this.week.name
            }
            return val;
          });
          this.option = res.d;
          this.getClass();
        }
      });
    },
    // 获取当前学期
    getSemester() {
      listSchoolSemester().then(res => {
        if (res.s == 1) {
          res.d.map(val => {
            if (val.present == 1) {
              this.semester = val;
            }
            return val;
          });
        }
      });
    },
    getClass() {
      myLessonTable({ searchWeek: this.week.week,month:0 }).then(res => {
        if(res.s==1){
          if(res.d)
          this.weekClass=this.disposeDate(res.d)
          this.hasClass = res.d.map(val => {
            return val.some(obj => {
              return obj.id;
            });
          });
          this.initData(this.week.beginDate);
          this.days.map((day,index)=>{
            if(day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()){
              this.pick(day,index)
            }
          })
        }
      });
    },
    getAdjustable(){
      exchangeLessonTable(this.classMsg).then(res => {
        if(res.s==1){
          this.weekClass=this.disposeDate(res.d)
          this.hasClass = res.d.map(val => {
            return val.some(obj => {
              return obj.id;
            });
          });
          this.initData(this.week.beginDate);
          this.days.map((day,index)=>{
            if(day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()){
              this.pick(day,index)
            }
          })
        }
      })
    },
    setWeek(item){
      let week=this.option.filter(val=>{
        return val.week==item
      })
      this.week = JSON.parse(JSON.stringify(week[0]))
      this.weekName = week[0].name
      if(this.classMsg.searchSchoolClassId){
        this.classMsg.searchTwoWeek = week[0].week
        this.getAdjustable()
      }else{
        this.getClass()
      }
    },
    closeBtn(){
      this.classMsg={}
      this.getClass()
    },
    // 申请调课
    apply_btn(obj) {
      if(obj.disabled){
        return false;
      }
      let replacObj = this.classMsg;
      let submitData = {
        schoolClassId: replacObj.searchSchoolClassId,
        replaceDate: replacObj.searchOneDate,
        replaceTeacherId: replacObj.searchOneTeacherId,
        replaceSubjectId: replacObj.subjectId,
        replaceSection: replacObj.searchOneSection,
        orignDate: obj.theDate,
        orignTeacherId: obj.teacherId,
        orignSubjectId: obj.subjectId,
        orignSection: obj.section
      };
      applyChange(submitData).then(res => {
        if (res.s == 1) {
          this.classMsg={}
          this.getClass();
          this.$message({
            message: '申请成功',
            type: 'success'
          });
        }else{
          this.$message.error(res.d);
        }
      });
    },
    selectCourse(item){
      if(item.disabled){
        return false;
      }
      this.classMsg = {
        searchTwoWeek: this.week.week,
        searchSchoolClassId: item.classId,
        searchOneTeacherId: item.teacherId,
        searchOneSection: item.section,
        searchOneDate: item.theDate,
        subjectId: item.subjectId,
        class:item.class,
        subject:item.subject
      }
      this.getAdjustable()
    },
    disposeDate(data){
      let ary=[]
      let now = new Date().setHours(0,0,0,0)
      data.forEach(item=>{
        item.forEach((val,index)=>{
          if(index==0){
            return false
          }
          if(!(ary[index-1] instanceof Array)){
            ary[index-1] = []
          }
          if(val.id){
            val.disabled = now > new Date(val.theDate.replace(/-/g,'/'))
          }
          ary[index-1].push(val)
        })
      })
      return ary
    },
    initData: function(cur) {
      var date;
      cur = cur.replace(/-/g, '/')
      if (cur) {
        date = new Date(cur);
      } else {
        date = new Date();
      }
      this.currentDay = date.getDate();
      this.currentYear = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;
      this.currentWeek = date.getDay(); // 1...6,0
      if (this.currentWeek == 0) {
        this.currentWeek = 7;
      }
      var str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      );
      // console.log("today:" + str + "," + this.currentWeek);
      this.days.length = 0;
      // 今天是周日，放在第一行第7个位置，前面6个
      for (var i = this.currentWeek - 1; i >= 0; i--) {
        var d = new Date(str);
        d.setDate(d.getDate() - i);
        // console.log("y:" + d.getDate());
        this.days.push(d);
      }
      for (var i = 1; i <= 28 - this.currentWeek; i++) {
        var d = new Date(str);
        d.setDate(d.getDate() + i);
        this.days.push(d);
      }

    },
    // 当前选择日期
    pick(date,index) {
      let week = ['周一','周二','周三','周四','周五','周六','周七']
      this.pitchDay = date;
      this.$emit('clickWeek', {weekClass:this.weekClass[index],date:this.$moment(new Date(date)).format('YYYY年MM月DD日')+week[index%7],week:this.week.week,oldDate:date})
    },
    pickPre: function(year, month) {
      // setDate(0); 上月最后一天
      // setDate(-1); 上月倒数第二天
      // setDate(dx) 参数dx为 上月最后一天的前后dx天
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    pickNext: function(year, month) {
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(35);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    pickYear: function(year, month) {
      alert(year + "," + month);
    },

    // 返回 类似 2016-01-02 格式的字符串
    formatDate: function(year, month, day) {
      var y = year;
      var m = month;
      if (m < 10) m = "0" + m;
      var d = day;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    }
  }
};
</script>

<style lang="less" scoped>
.adjust_ui{
  padding: 0 14Px 50Px;
  background: #fff;
  font-size: 14Px;
  color: #444;
  .adjust_title{
    display: flex;
    justify-content: space-between;
    margin: 25Px 0 18Px;
    .classMsg{
      min-width: 188Px;
      p{
        font-size: 13Px;
        line-height: 24Px;
        border: 1px solid #1890FF;
        padding: 0 50Px 0 8Px;
        position: relative;
        i{
          position: absolute;
          right: 7Px;
          top: 7Px;
          color: #1890FF;
        }
      }
    }
    .classSign{
      display: flex;
      span{
        padding-left: 15Px;
        position: relative;
        margin-left: 8Px;
        &::before{
          position: absolute;
          content: "";
          width: 7Px;
          height: 7Px;
          background: #FE7644;
          border-radius: 50%;
          left: 0;
          top: 6Px;
        }
        &.hasClass::before{
          background: #1890FF;
        }
        &.noClass::before{
          background: #05BD78;
        }
      }
    }
    /deep/ .el-dropdown{
      color: #191919;
    }
  }

  table{
    width: 100%;
    border: 1px solid #E4E4E4;
    th{
      background: #F1F5F6;
      height: 80Px;
      border: 1px solid #E4E4E4;
      width: 14.28571%;
      .date_box{
        color: #05BD78;
        margin-right: 6Px;
        &.hasClass{
          color: #1B90FF;
        }
      }
      .nowDate{
        width: 28Px;
        height: 28Px;
        border-radius: 50%;
        background: #1B90FF;
        color: #fff;
        display: inline-block;
        line-height: 28Px;
      }
    }
    td{
      border: 1px solid #E4E4E4;
      text-align: center;
      height: 99Px;
      p{
        margin: 6Px 0;
      }
      .current{
        p{
          text-align: right;
          padding-right: 10Px;
        }
      }
      .change-btn{
        font-size: 12Px;
        padding: 0 8Px;
        height: 30Px;
        line-height: 30Px;
        margin-bottom: 8Px;
        border-radius: 40Px;
      }
      .disabled{
        cursor: not-allowed;
        background: #c8c9cc;
        border-color: #c8c9cc;
      }
    }
    .hasTiaoke{
      .date_box{
        color: #444;
        &.hasClass{
          color: #FE7644;
        }
      }
    }
  }
}

.change-box{
  position: relative;
  .mySelect{
    position: absolute;
    left: 0;
    top: -8Px;
    height: 20Px;
    width: 100%;
    opacity: 0;
  }
}



</style>
